import { parseDateOnlyString } from "@gettactic/api";

/** A bare calendar day, the shape core stores a date field's answer in. */
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Formats a date that came off a request, without the day-shift `new Date`
 * introduces.
 *
 * A bare `YYYY-MM-DD` is parsed by `new Date` as UTC midnight, so anyone west
 * of UTC renders it as the day before — a start date of the 17th shown as the
 * 16th. These values name a calendar day, not an instant, so they are read in
 * the viewer's own zone instead.
 *
 * A value carrying a time is a real instant (a fixed `run_at`, which only the
 * API can author) and stays one.
 *
 * Returns `null` when there is nothing to show, and the raw string when it
 * can't be parsed — better a value the reader can recognise than a silent "—".
 */
export const formatRequestDate = (value: unknown): string | null => {
  if (typeof value !== "string" || !value) return null;

  const parsed = DATE_ONLY.test(value)
    ? parseDateOnlyString(value)
    : new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;

  return parsed.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
};
